/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChipDto } from '../../models/chip-dto';

export interface RestrictChip$Json$Params {
      body?: ChipDto
}

export function restrictChip$Json(http: HttpClient, rootUrl: string, params?: RestrictChip$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
  const rb = new RequestBuilder(rootUrl, restrictChip$Json.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChipDto>;
    })
  );
}

restrictChip$Json.PATH = '/v1/chips/restrict';
